import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f97316",
    },
    secondary: {
      main: "#2563eb",
    },
    background: {
      default: "#f8fafc",
    },
  },

  shape: {
    borderRadius: 12,
  },

  typography: {
    fontFamily: "'Inter', sans-serif",
  },
});

export default theme;
